import { render, staticRenderFns } from "./Keyboard65GameBoy.vue?vue&type=template&id=5a2bf99f&scoped=true&"
import script from "./Keyboard65GameBoy.vue?vue&type=script&lang=js&"
export * from "./Keyboard65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard65GameBoy.vue?vue&type=style&index=0&id=5a2bf99f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2bf99f",
  null
  
)

export default component.exports